/**
 * @group DataDeletion
 * @summary Token configuration constants for data deletion
 * 
 * <blockquote>
 * Configuration values for deletion request tokens including
 * expiry duration and token size.
 * </blockquote>
 * 
 * @example
 * ```typescript
 * import { DELETION_TOKEN_CONFIG } from '@shared/constants';
 * 
 * const expiresAt = new Date();
 * expiresAt.setHours(expiresAt.getHours() + DELETION_TOKEN_CONFIG.EXPIRY_HOURS);
 * ```
 */
export const DELETION_TOKEN_CONFIG = {
  /**
   * Number of hours until token expires
   */
  EXPIRY_HOURS: 24,
  
  /**
   * Token length in bytes (will be 128 hex characters)
   */
  TOKEN_BYTES: 64,
} as const;

